import React from 'react';
/** icon-chevron-right-strong-l */
/** icon-chevron-right-strong */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M8.708 3.738 C 8.495 3.814,8.263 3.975,8.057 4.190 C 7.609 4.657,7.573 5.172,7.953 5.675 C 8.034 5.782,9.375 7.242,10.933 8.919 C 12.666 10.785,13.757 11.989,13.744 12.023 C 13.733 12.053,12.458 13.439,10.912 15.104 C 9.365 16.769,8.034 18.218,7.953 18.325 C 7.561 18.845,7.610 19.361,8.098 19.850 C 8.650 20.402,9.201 20.456,9.726 20.011 C 9.899 19.865,13.458 16.053,15.961 13.333 C 16.488 12.761,16.666 12.183,16.504 11.574 C 16.404 11.196,16.232 10.958,15.441 10.103 C 11.858 6.228,9.916 4.150,9.726 3.989 C 9.392 3.706,9.040 3.619,8.708 3.738 "
            stroke="none"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
